import { getHoverTipContent } from "@/Utils/Misc";
import { GetDoc } from "@/Utils/StateLib";
import { enumObjectTypes, objTypeClassMap } from "@coreapp/constants";

/**
 * Override can be as a format override or it can be a data object from the override manager
 *
 * @param {*} override
 * @param {string=} id
 * @returns
 */
export const GetDBFromOverride = (override, id) => {
  const recordID = id ?? override?.SmartGetFieldValue?.("RefID") ?? override.objID;
  const doc = GetDoc();
  const objDB = doc.GetObjDB();
  const objType =
    override.SmartGetFieldValue?.("objType") ??
    (override.isPosition !== undefined && override.isPosition
      ? enumObjectTypes.position
      : enumObjectTypes.holder) ??
    enumObjectTypes.holder;
  const className = objTypeClassMap[objType];
  const objClass = objDB.GetClassByName(className);
  const recordIDFieldDef = objClass.GetRecordIDFieldDef();
  return objClass.FindObject(recordIDFieldDef, recordID, true);
};

export const BuildChartDataOverrideActions = ({
  override,
  changeHandlers,
  prefix,
  uniqueId,
  objDB
}) => {
  const actions = [];
  if (changeHandlers?.handleOverrideNavigation) {
    actions.push({
      iconName: "sitemap",
      tooltipProps: getHoverTipContent("Navigate to record in chart"),
      onClick: () => changeHandlers.handleOverrideNavigation(override, objDB)
    });
  }

  if (changeHandlers?.handleProfile) {
    actions.push({
      iconName: "address-card",
      tooltipProps: getHoverTipContent("Open profile"),
      dataTestId: prefix + "-profile-override-action-" + uniqueId,
      onClick: () => changeHandlers.handleProfile(override)
    });
  }

  if (changeHandlers?.handleRecordInfo) {
    actions.push({
      iconName: "circle-info",
      tooltipProps: getHoverTipContent("Open record details"),
      onClick: () => changeHandlers.handleRecordInfo(override)
    });
  }

  if (changeHandlers?.handleDeleteOverride) {
    actions.push({
      iconName: "trash-can",
      iconProps: { color: "error" },
      tooltipProps: getHoverTipContent("Delete changes to record"),
      onClick: () => changeHandlers.handleDeleteOverride(override),
      dataTestId: prefix + "-delete-override-action-" + uniqueId
    });
  }

  return [...actions];
};
